import styled from "styled-components";
import ProgressBarForHome from "./ProgressBarForHome";
import { ReactComponent as ArrowUp } from "../../../assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrow-down.svg";
import { useTranslation } from "react-i18next";
import i18n from "_i18n/i18n";

const infoStyle: React.CSSProperties = {
  width: "200px",
  textWrap: "wrap",
  textAlign: "center",
};

export const EnduraceInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.endurance")}
    </div>
  );
};

export const IntensityInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.intensity")}
    </div>
  );
};

export const DynamicInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.dynamic")}
    </div>
  );
};

export const HrrInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.hrr")}
    </div>
  );
};

export const HeartRateInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <p>{t("home.tooltips.heartRateIntro")}</p>

        <div style={{ padding: "5px 0px" }}></div>

        <li style={{ textAlign: "center" }}> {t("home.tooltips.heartRateZone1")}</li>
        <li style={{ textAlign: "center" }}> {t("home.tooltips.heartRateZone2")}</li>
        <li style={{ textAlign: "center" }}> {t("home.tooltips.heartRateZone3")}</li>

        <li style={{ textAlign: "center" }}> {t("home.tooltips.heartRateZone4")}</li>
        <li style={{ textAlign: "center" }}> {t("home.tooltips.heartRateZone5")}</li>
      </ul>
    </div>
  );
};

export const PowerInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.power")}
    </div>
  );
};

export const PizInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <p>
          {t("home.tooltips.pizIntro")}
          <br />
          <p
            style={{
              fontWeight: 700,
              fontSize: "14px",
            }}
          >
            {t("home.tooltips.pizThresholdsTitle")}
          </p>
        </p>
        <div style={{ padding: "2px 0px" }}></div>

        <li>{t("home.tooltips.pizU10U12")}</li>
        <li>{t("home.tooltips.pizU13U14")}</li>
        <li>{t("home.tooltips.pizU15U16")}</li>
        <li>{t("home.tooltips.pizU17Plus")}</li>
      </ul>
    </div>
  );
};

export const HMLDInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <p>{t("home.tooltips.hmldIntro")}</p>

        <div style={{ padding: "5px 0px" }}></div>

        <li>{t("home.tooltips.hmldTotal")}</li>
        <li>{t("home.tooltips.hmldPercent")}</li>
      </ul>
    </div>
  );
};

export const TTSInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <p>{t("home.tooltips.ttsIntro")}</p>
        <div style={{ padding: "5px 0px" }}></div>

        <li>{t("home.tooltips.ttsU10U12")}</li>
        <li>{t("home.tooltips.ttsU13U14")}</li>
        <li>{t("home.tooltips.ttsU15U16")}</li>
        <li>{t("home.tooltips.ttsU17Plus")}</li>
      </ul>
    </div>
  );
};

export const SprintInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <p>{t("home.tooltips.sprintIntro")}</p>
      <div style={{ padding: "5px 0px" }}></div>
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <li>{t("home.tooltips.sprintU10U12")}</li>
        <li>{t("home.tooltips.sprintU13U14")}</li>
        <li>{t("home.tooltips.sprintU15U16")}</li>
        <li>{t("home.tooltips.sprintU17Plus")}</li>
      </ul>
    </div>
  );
};

export const HSRInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <p>{t("home.tooltips.hsrIntro")}</p>
      <div style={{ padding: "5px 0px" }}></div>
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <li>{t("home.tooltips.hsrU10U12")}</li>
        <li>{t("home.tooltips.hsrU13U14")}</li>
        <li>{t("home.tooltips.hsrU15U16")}</li>
        <li>{t("home.tooltips.hsrU17Plus")}</li>
      </ul>
    </div>
  );
};

export const RunInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <p>{t("home.tooltips.runIntro")}</p>
      <div style={{ padding: "5px 0px" }}></div>
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <li>{t("home.tooltips.runU10U12")}</li>
        <li>{t("home.tooltips.runU13U14")}</li>

        <li>{t("home.tooltips.runU15U16")}</li>
        <li>{t("home.tooltips.runU17Plus")}</li>
      </ul>
    </div>
  );
};

export const DistanceInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
        width: "300px",
      }}
    >
      <p>{t("home.tooltips.distanceIntro")}</p>
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
        }}
      >
        <li>{t("home.tooltips.distanceTotal")}</li>
        <li>{t("home.tooltips.distanceAvg")}</li>
      </ul>
    </div>
  );
};

export const VMAXInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.vmax")}
    </div>
  );
};

export const TasksInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.tasks")}
    </div>
  );
};

export const PotencialInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.potential")}
    </div>
  );
};

export const ReadinessInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.readiness")}
    </div>
  );
};

export const FormInfo = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...infoStyle,
      }}
    >
      {t("home.tooltips.form")}
    </div>
  );
};

export const TrendInfoLegend = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        listStyle: "none",
        paddingLeft: "0px",
        display: "flex",
        flexDirection: "column",
        color: "white",
        fontSize: "9px",
        border: "2px solid #334452",
        borderRadius: "5px",
        padding: "2px 10px",
      }}
    >
      <div style={{ display: "flex" }}>
        <div style={{ color: "green", marginRight: "8px" }}>●</div>
        <div style={{ textAlign: "start" }}>{t("home.aboveAvg")}</div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ color: "#4bc0c0", marginRight: "8px" }}>●</div>
        <div style={{ textAlign: "start" }}>{t("home.withinAvg")}</div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ color: "red", marginRight: "8px" }}>●</div>
        <div
          style={{
            textAlign: "start",
          }}
        >
          {t("home.belowAvg")}
        </div>
      </div>
    </div>
  );
};

const DotStyledSpan = styled.span<{ value: number; avgValue: number }>`
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 3px 0 0;
  position: relative;
`;

export const getStyledSpan = (value: number | string = 0, avgValue: number | string = 0) => {
  const isString = typeof value === "string";

  const numericValue = parseFloat(String(value).replace(",", ".")) || 0;
  const numericAvgValue = parseFloat(String(avgValue).replace(",", ".")) || 0;

  let minimumFractionDigits = 0;
  let maximumFractionDigits = 0;

  if (isString) {
    const v = String(value);

    if (v.includes(",")) {
      const decimals = v.split(",")[1] || "";
      minimumFractionDigits = decimals.length;
      maximumFractionDigits = decimals.length;
    } else if (v.includes(".")) {
      const decimals = v.split(".")[1] || "";
      minimumFractionDigits = decimals.length;
      maximumFractionDigits = decimals.length;
    }
  }

  const formattedValue = numericValue.toLocaleString("pl-PL", {
    minimumFractionDigits,
    maximumFractionDigits,
    useGrouping: true,
  });

  return (
    <DotStyledSpan value={numericValue} avgValue={numericAvgValue}>
      <div
        style={{
          padding: "0 10px 0 0",
          width: "100%",
          background: "transparent",
        }}
      >
        {formattedValue}
      </div>
    </DotStyledSpan>
  );
};

const TooltipWrapper: React.FC<{ children: React.ReactNode; title: string }> = ({
  children,
  title,
}) => {
  return (
    <div style={{ position: "relative", display: "block", width: "100%" }}>
      {children}
      <span
        style={{
          visibility: "hidden",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          color: "#fff",
          textAlign: "left",
          borderRadius: "4px",
          padding: "6px 10px",
          position: "absolute",
          zIndex: 100,
          bottom: "125%",
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "pre-line",
          fontSize: "12px",
          opacity: 0,
          transition: "opacity 0.3s",
          pointerEvents: "none",
        }}
        className="tooltipText"
      >
        {title}
      </span>
      <style>
        {`
          div:hover > .tooltipText {
            visibility: visible;
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
};

export const getStyledSpanWithProgressbar = (
  value: number | string = 0,
  maxValue: number | string = 0,
  minValue: number | string = 0,
  medianValue?: number | string | null
) => {
  const numericValue = parseFloat(String(value).replace(",", ".")) || 0;
  const numericMaxValue = parseFloat(String(maxValue).replace(",", ".")) || 0;
  const numericMinValue = parseFloat(String(minValue).replace(",", ".")) || 0;
  const numericMedianValue =
    medianValue != null ? parseFloat(String(medianValue).replace(",", ".")) : NaN;

  let minimumFractionDigits = 0;

  if (typeof value === "string" && value.includes(",")) {
    const decimals = value.split(",")[1] || "";
    if (decimals.length > 0) {
      minimumFractionDigits = decimals.length;
    }
  } else if (typeof value === "string" && value.includes(".")) {
    const decimals = value.split(".")[1] || "";
    if (decimals.length > 0) {
      minimumFractionDigits = decimals.length;
    }
  }

  const formattedValues = numericValue.toLocaleString("pl-PL", {
    maximumFractionDigits: 3,
    minimumFractionDigits,
    useGrouping: true,
  });

  const range = numericMaxValue - numericMinValue;
  const rawProgressPercent = range !== 0 ? ((numericValue - numericMinValue) / range) * 100 : 0;
  const progressPercent = Number.isFinite(rawProgressPercent) ? rawProgressPercent : 0;
  const progressText = i18n.isInitialized
    ? i18n.t("home.progress", { percent: progressPercent.toFixed(0) })
    : `Postęp: ${progressPercent.toFixed(0)}%`;
  const deviationPercent =
    Number.isFinite(numericMedianValue) && numericMedianValue !== 0
      ? ((numericValue - numericMedianValue) / numericMedianValue) * 100
      : null;
  const colorVariant: "negative" | "neutral" | "positive" =
    deviationPercent == null
      ? "neutral"
      : deviationPercent <= -10
      ? "negative"
      : deviationPercent >= 10
      ? "positive"
      : "neutral";

  return (
    <TooltipWrapper title={progressText}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
        }}
      >
        <div style={{ width: "100%" }}>
          <ProgressBarForHome
            minValue={numericMinValue}
            maxValue={numericMaxValue}
            currentValue={numericValue}
            num={formattedValues}
            colorVariant={colorVariant}
          />
        </div>
      </div>
    </TooltipWrapper>
  );
};

export const renderTrendSpan = (
  value: number | string = 0,
  trendValue?: number | string | null
) => {
  const numericValue = parseFloat(String(value).replace(",", ".")) || 0;

  const numericTrendValue =
    trendValue != null ? parseFloat(String(trendValue).replace(",", ".")) : undefined;

  let direction: "up" | "down" | "neutral" = "neutral";

  if (numericTrendValue !== undefined && !Number.isNaN(numericTrendValue)) {
    if (numericTrendValue > 0) {
      direction = "up";
    } else if (numericTrendValue < 0) {
      direction = "down";
    } else {
      direction = "neutral";
    }
  }

  const displayTrend =
    numericTrendValue !== undefined && !Number.isNaN(numericTrendValue)
      ? Math.abs(numericTrendValue)
      : null;

  const formattedValue = numericValue.toLocaleString("pl-PL", {
    minimumFractionDigits: String(value).includes(",") ? 2 : 0,
    maximumFractionDigits: 3,
    useGrouping: true,
  });

  const formattedTrend =
    displayTrend !== null
      ? displayTrend.toLocaleString("pl-PL", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 3,
          useGrouping: true,
        })
      : "–";

  return (
    <TrendStyledSpan direction={direction}>
      <div className="col value-col">
        <div className="value">{formattedValue}</div>
      </div>

      <div className="col trend-col">
        {numericTrendValue !== undefined && !Number.isNaN(numericTrendValue) ? (
          <div className="trendWrapper">
            {direction === "up" && <ArrowUp className="icon up" />}
            {direction === "down" && <ArrowDown className="icon down" />}
            {direction === "neutral" && <div className="empty-icon" />}
            <div className={`trend ${direction}`}>{formattedTrend}</div>
          </div>
        ) : (
          <div className="trendWrapper">
            <div className="empty-icon" />
            <div className="trend neutral">–</div>
          </div>
        )}
      </div>
    </TrendStyledSpan>
  );
};

export const TrendStyledSpan = styled.span<{
  direction?: "up" | "down" | "neutral";
}>`
  display: flex;
  gap: 8px;
  width: 120px;
  height: 26px;
  display: flex;
  flex-direction: row;

  overflow: hidden;
  position: relative;

  .col {
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .value-col {
    padding-right: 0; /* no extra padding */
  }

  .trend-col {
    padding-right: 9px;
  }

  .value {
    padding-top: 1px;
    width: 100%;
    text-align: right;
  }

  .trendWrapper {
    display: flex;
    align-items: center;
  }

  .icon {
    width: 11px;
    height: 11px;
    margin-right: 3px; /* ← arrow right padding (3px) */
  }

  .empty-icon {
    width: 11px;
    margin-right: 3px;
  }

  .up {
    fill: #32ff32;
    margin-top: 1.5px;
  }

  .down {
    fill: #ff3232;
    margin-top: 0.9px;
    padding-top: 1px;
  }

  .trend {
    font-size: 12px;
    font-weight: 500;
    padding-top: 4px;
  }

  .trend.up {
    color: #afafafff;
    margin-top: -1px;
  }

  .trend.down {
    color: #afafafff;
    margin-top: -1px;
  }

  .trend.neutral {
    color: #4bc0c0;
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 100%;
    pointer-events: none;

    background: ${({ direction }) => {
      if (direction === "up")
        return `
          linear-gradient(
            to left,
            rgba(0, 255, 0, 0.23) 0%,
            rgba(0, 255, 0, 0.15) 25%,
            rgba(0, 255, 0, 0.07) 55%,
            rgba(0, 0, 0, 0) 100%
          )
        `;
      if (direction === "down")
        return `
          linear-gradient(
            to left,
            rgba(255, 0, 0, 0.23) 0%,
            rgba(255, 0, 0, 0.15) 25%,
            rgba(255, 0, 0, 0.07) 55%,
            rgba(0, 0, 0, 0) 100%
          )
        `;
      return `
        linear-gradient(
          to left,
          rgba(75, 192, 192, 0.23) 0%,
          rgba(75, 192, 192, 0.15) 25%,
          rgba(75, 192, 192, 0.07) 55%,
          rgba(0, 0, 0, 0) 100%
        )
      `;
    }};
  }
`;

// Styles for Home Table

export const flexEndClass: React.CSSProperties = {
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
};

export const stickyThStyle: React.CSSProperties = {
  position: "sticky" as const,
  top: 0,
  zIndex: 100,
  borderBottom: "6px solid #10293e",
  textAlign: "center",
  fontWeight: 400,
};

export const flexClass: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const arrowStyle: React.CSSProperties = {
  width: "15px",
  height: "13px",
  marginLeft: "4px",
  color: "#606e7a",
  cursor: "pointer",
};

export const mainTableHeaderBgColor: React.CSSProperties = {
  color: "#f8f8f8",
};

export const academyStatsRows: React.CSSProperties = {
  //background: '#273e52',
  height: "26px",
  color: "rgba(248, 248, 248, 0.698)",
  textAlign: "end",
  paddingRight: "13px",
  // borderLeft: "2px solid #10293e",
  fontWeight: 400,
};

export const headerColOddBgColor: React.CSSProperties = {
  //background: '#3a4e5e',
  color: "#f8f8f8",
  fontWeight: 500,
};

export const headerColEvenBgColor: React.CSSProperties = {
  //background: '#415669',
  color: "#f8f8f8",
  fontWeight: 500,
};

export const headerSortOddUnitBgColor: React.CSSProperties = {
  //background: '#2a3f50',
  fontWeight: 400,
  color: "rgba(248, 248, 248, 0.698)",
  borderRight: "0",
};

export const headerSortEvenUnitBgColor: React.CSSProperties = {
  //background: '#344756',
  fontWeight: 400,
  color: "rgba(248, 248, 248, 0.698)",
  borderRight: "0",
};

///home cols

export const HOME_COLS_LS_KEY = "homeColsCheckboxes";
export const HOME_COLS_ORDER_LS_KEY = "homeColsOrder:v1";

export const initialCheckboxes = {
  klub: { name: "KLUB", active: true, locked: true },
  poz: { name: "POZYCJA", active: false },
  lat: { name: "LAT", active: false },
  phv: { name: "PHV", active: false },
  // forma: { name: 'FORMA', active: false },
  dyspozycja: { name: "DYSPOZYCJA", active: false },
  /*  potencjal: { name: 'POTENCJAŁ', active: false }, */
  zadan: { name: "ZADAŃ", active: true, locked: true },
  czas: { name: "CZAS", active: true },
  dziennik: { name: "DZIENNIK", active: true },
  vmax: { name: "V MAX", active: true },
  dystans: { name: "DYSTANS", active: true },
  bieg: { name: "BIEG", active: false },
  hsr: { name: "HSR", active: false },
  sprint: { name: "SPRINT", active: false },
  tts: { name: "TTS", active: false },
  hmld: { name: "HMLD", active: false },
  accDec: { name: "ACC/DEC", active: false },
  moc: { name: "MOC", active: false },
  tetno: { name: "TĘTNO", active: false },
  kalorie: { name: "KALORIE", active: false },
  playerLoad: { name: "PLAYER LOAD", active: false },
  // dynamika: { name: "DYNAMIKA", active: false },
  /* intensywnosc: { name: "INTENSYWNOŚĆ", active: false }, */
  /* wytrzymalosc: { name: "WYTRZYMAŁOŚĆ", active: false }, */
};

export type CheckboxKey =
  | "klub"
  | "poz"
  | "lat"
  | "phv"
  // | 'forma'
  | "dyspozycja"
  /*   | 'potencjal' */
  | "zadan"
  | "czas"
  | "dziennik"
  | "vmax"
  | "dystans"
  | "bieg"
  | "hsr"
  | "sprint"
  | "tts"
  | "hmld"
  | "accDec"
  | "moc"
  | "tetno"
  | "kalorie"
  | "playerLoad"
  /* | "dynamika" */
  /* | "intensywnosc" */
  /* | "wytrzymalosc" */

export const DEFAULT_HOME_COLUMN_ORDER: CheckboxKey[] = [
  "klub",
  "zadan",
  "vmax",
  "dystans",
  "poz",
  "lat",
  "phv",
  "dyspozycja",
  "czas",
  "dziennik",
  "bieg",
  "hsr",
  "sprint",
  "tts",
  "hmld",
  "accDec",
  "moc",
  "tetno",
  "kalorie",
  "playerLoad",
  /* "dynamika", */
  /* "intensywnosc", */
  /* "wytrzymalosc", */
];

export const LOCKED_HOME_COLUMN_KEYS: CheckboxKey[] = ["klub", "zadan"];

export const EDITABLE_HOME_COLUMN_KEYS = DEFAULT_HOME_COLUMN_ORDER.filter(
  (key) => !LOCKED_HOME_COLUMN_KEYS.includes(key)
);

export const normalizeHomeColumnOrder = (value?: unknown): CheckboxKey[] => {
  if (!Array.isArray(value)) return [...DEFAULT_HOME_COLUMN_ORDER];

  const savedKeys = value
    .filter(
      (key): key is CheckboxKey =>
        typeof key === "string" && DEFAULT_HOME_COLUMN_ORDER.includes(key as CheckboxKey)
    )
    .filter((key, index, keys) => keys.indexOf(key) === index);
  const savedEditableKeys = savedKeys.filter((key) => !LOCKED_HOME_COLUMN_KEYS.includes(key));
  const missingEditableKeys = EDITABLE_HOME_COLUMN_KEYS.filter(
    (key) => !savedEditableKeys.includes(key)
  );
  const normalizedEditableKeys = [...savedEditableKeys, ...missingEditableKeys];
  let editableIndex = 0;

  return DEFAULT_HOME_COLUMN_ORDER.map((key) =>
    LOCKED_HOME_COLUMN_KEYS.includes(key) ? key : normalizedEditableKeys[editableIndex++]
  );
};

export interface CheckboxItem {
  name: string;
  active: boolean;
  locked?: boolean;
}

export type CheckboxesState = Record<CheckboxKey, CheckboxItem>;

export const normalizeHomeColsCheckboxes = (
  value?: Partial<CheckboxesState> | null
): CheckboxesState => {
  const merged = {
    ...initialCheckboxes,
    ...(value ?? {}),
  } as CheckboxesState;

  return Object.fromEntries(
    Object.entries(merged).map(([key, item]) => [
      key,
      {
        ...item,
        locked: LOCKED_HOME_COLUMN_KEYS.includes(key as CheckboxKey) ? true : undefined,
      },
    ])
  ) as CheckboxesState;
};
